import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvrideoCommonModule } from "../common/evrideo-common.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ToastrModule } from "ngx-toastr";
import { RouterModule } from "@angular/router";
import { InlineSVGModule } from "ng-inline-svg-2";
import { FormsModule } from "@angular/forms";
import { MonitoringComponent } from "./monitoring.component";
import { MonitoringRoutes } from "./monitoring.routes";
import { MonitoringStatusComponent } from "./status/monitoring-status.component";
import { MonitoringTargetsComponent } from "./targets/monitoring-targets.component";
import { MonitoringAlertsComponent } from "./alerts/monitoring-alerts.component";
import { MonitoringEventLogComponent } from "./event-log/monitoring-event-log.component";
import { MonitoringChartComponent } from "./chart/monitoring-chart.component";
import { IMonitoringRepository } from "../../domain/monitoring/monitoring-repository";
import { MonitoringRepository } from "../../infrastructure/monitoring/monitoring-repository";
import { AngularDraggableModule } from "angular2-draggable";
import { TargetDetailsPopupComponent } from "./targets/target-details-popup/target-details-popup.component";
import { IMonitoringErrorsRepository } from "../../domain/monitoring/i-monitoring-errors-repository";
import { MonitoringErrorsRepository } from "../../infrastructure/monitoring/monitoring-errors-repository.service";
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    EvrideoCommonModule,
    BrowserAnimationsModule,
    AngularDraggableModule,
    InlineSVGModule.forRoot(),
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 5000,
    }),
    RouterModule.forRoot(MonitoringRoutes),
  ],
  declarations: [
    MonitoringComponent,
    MonitoringStatusComponent,
    MonitoringTargetsComponent,
    MonitoringAlertsComponent,
    MonitoringEventLogComponent,
    MonitoringChartComponent,
    TargetDetailsPopupComponent,
  ],
  providers: [
    {
      provide: IMonitoringRepository,
      useClass: MonitoringRepository,
    },
    {
      provide: IMonitoringErrorsRepository,
      useClass: MonitoringErrorsRepository,
    },
  ],
  exports: [RouterModule, InlineSVGModule, ToastrModule],
})
export class MonitoringModule {}
